// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://apigopaljewels.manjitjewellers.com/",
});

export default axiosInstance;

// export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const weburl = "https://apigopaljewels.manjitjewellers.com/";
export const testurl = "https://apigopaljewels.manjitjewellers.com/";
export const ImageServer = "https://gopaljewelscloud.manjitjewellers.com/";

export const shopurl = "https://parijaadmin.servicekarwalo.com/";
export const mainurl = "https://parijaapp.servicekarwalo.com/";
export const fronturl = "https://parijaapp.servicekarwalo.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;